import { Box, Button, Grid, Typography } from "@mui/material";
import { type FC } from "react";
import { DEFAULT_TXT } from "../../utils/constants";

type TopUserInfoBlockProps = {
  userInfo: any;
};

const handleLogOutClick = () => {
  window.location.href = "/aigc/portal/";
};

export const TopUserInfoBlock: FC<TopUserInfoBlockProps> = ({ userInfo }) => {
  const user_info_items = [
    {
      label: "会员昵称",
      value: userInfo.nickname ?? DEFAULT_TXT,
    },
    {
      label: "会员到期时间",
      value: userInfo["expires_in"] ?? new Date().toLocaleDateString(),
    },
    {
      label: "今日魔法余额",
      value: userInfo.point ?? DEFAULT_TXT,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "50%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
        zIndex: 1,
      }}
    >
      {user_info_items.map((item, index) => (
        <Grid
          container
          spacing={3}
          key={`user-info-item-${index}`}
          sx={{ width: "100%" }}
        >
          <Grid
            size={6}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" fontWeight="bold">
              {item.label}
            </Typography>
          </Grid>
          <Grid size={6} sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="h6">{item.value}</Typography>
          </Grid>
        </Grid>
      ))}
      <Button
        variant="outlined"
        onClick={handleLogOutClick}
        sx={{
          marginTop: "16px",
          fontWeight: 800,
          fontSize: "15px",
          boxShadow: "2px 2px 5px rgba(0,0,0,0.3)",
        }}
        size="small"
      >
        退出登陆
      </Button>
    </Box>
  );
};

/**
 * 商户号：1717484883
 * AppID：wx5e7a6a160915a190
 */
